import { createContext, useContext, ReactNode } from 'react'
import ApiClient from '../ApiClient'
import { AppProps } from '../index'

export interface AppContextValue extends AppProps {
  api?: ApiClient | null
}

const AppContext = createContext<AppContextValue | undefined>(undefined)

interface AppProviderProps {
  value: AppContextValue
  children: ReactNode
}

export const AppProvider = ({ value, children }: AppProviderProps) => {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export const useAppContext = () => {
  const context = useContext(AppContext)
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider')
  }
  return context
}
